import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import ResultTab from './result-tab/ResultTab';
import Slider from "react-slick";
import TextResult from '../../components/TextResult/TextResult';
import { clearResults, setCurrentItem } from '../../redux/actions/result.action';
import VideoThumbnail from '../../components/VideoThumbnail/VideoThumbnail';
import ImageThumbnail from '../../components/ImageThumbnail/ImageThumbnail';
import './ResultScreen.scss';
import "react-tabs/style/react-tabs.css";

//icons
import videoIcon from '../../assets/video.png';
import videoInavtive from '../../assets/video_gray.png';
import photoIcon from '../../assets/photo.png';
import photoInactiveIcon from '../../assets/photo_gray.png';
import textIcon from '../../assets/text.png';
import textInactiveIcon from '../../assets/text_gray.png';
import backArrow from '../../assets/backArrow.png';
import forwardArrow from '../../assets/forwardArrow.png';
import speakerIcon from '../../assets/speaker.svg';

//text
import assistantText from '../../assets/text/text.json';
import { setTextToSpeak } from '../../redux/actions/text.action';
import Text2Voice from '../../components/Text2Voice/Text2Voice';

/**
 * Home page component
 */
class ResultScreen extends Component<{ navigateTo: any, active: string, search: any, searchTerm: string, videoResult: any, imageResult: any, webResult: any, back: any, speak: any, setCurrent: any }, { index: number, message: string, playing: boolean }> {
    private slickSlider: any;
    constructor(props: any) {
        super(props);
        this.state = {
            index: 0,
            message: '',
            playing: false
        }
    }
    renderContent() {
        if (this.props.active === 'video') {
            console.log(this.props.videoResult)
            return this.props.videoResult.map((item: any, key: any) => {
                return (
                    <VideoThumbnail video={item} key={key} />
                )
            })
        }
        if (this.props.active === 'photo') {
            return this.props.imageResult.map((item: any, key: any) => {
                return (
                    <ImageThumbnail image={item} key={key} />
                )
            })
        }
        if (this.props.active === 'text') {
            return this.props.webResult.map((item: any, key: any) => {
                return (
                    <TextResult text={item} key={key} />
                )
            })
        }
    }

    generateBottomCenter() {
        if (this.props.active === 'video') {
            const video: any = this.props.videoResult[this.state.index];
            if (!video) {
                return (
                    <div></div>
                )
            }
            return (
                <div className="videotitle">
                    {video.name}
                </div>
            )
        }
        if (this.props.active === 'text') {
            const text: any = this.props.webResult[this.state.index];
            if (!text) {
                return (
                    <div></div>
                )
            }
            return (
                <div>
                    <img src={speakerIcon} className="speaker" alt="speaker" onClick={() => {
                        setTimeout(() => {
                            this.setState({ message: text.snippet, playing: true });
                        }, 500)
                        this.setState({ message: '' })
                        //  this.setState({message: ''})
                    }} />
                </div>
            )
        }
    }

    renderBody() {
        var settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 1,
            centerPadding: '60px',
            centerMode: true,
            arrows: false,
            afterChange: (i: any) => {

            },
            beforeChange: (slick: any, currSlide: any, i: any) => {
                this.setState({ index: currSlide });
            }
        };
        return (
            <div className="container">
                <div className="tab-container">
                    <ResultTab title="Videos" type="video" imageActive={videoIcon} imageInactive={videoInavtive} onClick={() => {
                        console.log(this.slickSlider);
                        this.slickSlider.slickGoTo(0);
                    }} />
                    <ResultTab title="Texte" type="text" imageActive={textIcon} imageInactive={textInactiveIcon} onClick={() => {
                        this.slickSlider.slickGoTo(0);
                    }} />
                    <ResultTab title="Bilder" type="photo" imageActive={photoIcon} imageInactive={photoInactiveIcon} onClick={() => {
                        this.slickSlider.slickGoTo(0);
                    }} />
                </div>
                <div className="slick-container">
                    <Slider {...settings} ref={(ref: any) => { this.slickSlider = ref }}>
                        {this.renderContent()}
                    </Slider>
                </div>
                <div className="bottom">
                    <img src={backArrow} className="arrow" alt="arrow" onClick={() => {
                        if (this.slickSlider) {
                            this.slickSlider.slickPrev();
                            this.setState({ message: '' })
                        }
                    }} />
                    {this.generateBottomCenter()}
                    <img src={forwardArrow} className="arrow" alt="arrow" onClick={() => {
                        if (this.slickSlider) {
                            this.slickSlider.slickNext();
                            this.setState({ message: '' })
                        }
                    }} />
                </div>
                {this.state.message != '' && <Text2Voice textArray={[this.state.message]} playing={this.state.playing} callback={() => {
                    this.setState({ message: '', playing: false })
                }} />}
            </div>
        )
    }

    /**
     * inject the searchterm in the text of the assistant
     */
    private includeSearchTerm(inputText: string) {
        console.log(inputText);
        return inputText.replace('%input', this.props.searchTerm.toUpperCase());
    }

    /**
     * Main render method of component
     */
    render() {
        return (
            <div className="resultscreen">
                <PageTemplate assistantLine1={this.includeSearchTerm(assistantText.resultScreen.Assistant.line1)} assistantLine2="" body={this.renderBody()} text={['']} customBack={() => {
                    this.props.back();
                }} />
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        active: state.result.active,
        searchTerm: state.result.searchTerm,
        videoResult: state.result.searchResultVideo,
        imageResult: state.result.searchResultPhoto,
        webResult: state.result.searchResultWeb
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        navigateTo(path: string) {
            dispatch(push(path))
        },
        back() {
            dispatch(clearResults());
            dispatch(goBack());
        },
        speak(text: string) {
            dispatch(setTextToSpeak(text));
        },
        setCurrent(item: any) {
            dispatch(setCurrentItem(item));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResultScreen);